<div class="route-component">
    <div class="search-component">
        <h4>
            Users
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['User', 'Create']" (click)="upsertUser(0)">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['User', 'Export']" (click)="downloadUsers(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="users"
            [paging]="paging"
            [columns]="getColumnMap()"
            [useSwitch]="true"
            [switchField]="'isActive'"
            (switchChanged)="toggleUserStatus($event)"
            (refreshData)="getUsers($event)"
            [showEdit]="showEdit || false"
            (editItem)="upsertUser($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deleteUser($event)">
        </pageable-table>
    </div>
</div>